import React from "react";
import "./FormSectionCard.css";

/**
 * Shared bordered section for quotes/contracts: Line Items, Internal Notes, etc.
 */
export default function FormSectionCard({
  title,
  subtitle,
  headlineIcon,
  children,
  className,
  contentClassName,
  noBorder = false,
}) {
  return (
    <section
      className={[
        "cs-form-section",
        noBorder ? "cs-form-section--no-border" : "",
        className || "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {(title || subtitle || headlineIcon) && (
        <header className="cs-form-section__head">
          {headlineIcon ? (
            <span className="cs-form-section__icon">{headlineIcon}</span>
          ) : null}
          <div>
            {title ? <h2 className="cs-form-section__title">{title}</h2> : null}
            {subtitle ? (
              <p className="cs-form-section__subtitle">{subtitle}</p>
            ) : null}
          </div>
        </header>
      )}
      <div
        className={["cs-form-section__body", contentClassName || ""]
          .filter(Boolean)
          .join(" ")}
      >
        {children}
      </div>
    </section>
  );
}
